module.exports = __webpack_public_path__ + "static/img/rabbit.4362711f.png";